import React, { HTMLAttributeReferrerPolicy, MouseEventHandler, ReactElement } from 'react';
import { Link } from 'react-router-dom';

import { IParentProps } from '../../shared/types/IParentProps';
import { IQATestableProps } from '../../shared/types/IQATestableProps';
import { IStyleableProps } from '../../shared/types/IStyleableProps';

import { BUTTON_SIZE } from './BUTTON_SIZE';
import { BUTTON_STYLE } from './BUTTON_STYLE';
import { SizedButton } from './SizedButton';
import { StyledButton } from './StyledButton';

export type IButtonProps = IParentProps & IQATestableProps & IStyleableProps & {
    onClick?: MouseEventHandler;
    to?: string;
    href?: string;
    disabled?: boolean;
    referrerPolicy?: HTMLAttributeReferrerPolicy;
    size?: BUTTON_SIZE;
    style?: BUTTON_STYLE;
};

export function OzButton (props: IButtonProps): ReactElement {
    const {
        to,
        href,
        onClick,
        disabled = false,
        children,
        'data-testid': dataTest,
        referrerPolicy,
        className = '',
        size = BUTTON_SIZE.MEDIUM,
        style = BUTTON_STYLE.PRIMARY,
    }: IButtonProps = props;

    const baseProps: Pick<IButtonProps, 'onClick' | 'data-testid' | 'className'> = {
        onClick,
        'data-testid': dataTest,
        className,
    };

    let button: ReactElement = <button {...baseProps} type="button" disabled={disabled}>{children}</button>;

    if (to) {
        button = <Link {...baseProps} referrerPolicy={referrerPolicy} to={to}>{children}</Link>;
    }

    if (href) {
        button = <a {...baseProps} referrerPolicy={referrerPolicy} href={href}>{children}</a>;
    }

    return (
        <StyledButton style={style}>
            <SizedButton size={size} style={style}>
                {button}
            </SizedButton>
        </StyledButton>
    );
}
